import store from "@/store";
export default {
  bind(el, binding, vnode, oldVnode) {
    
  },
  inserted(el, binding, vnode) {
    if (!el) return;
    const btnType = binding.value.split(",");
    const hasPermission = btnType.find(item =>
      store.state.user.btnPermissions.includes(item)
    );
    if (!hasPermission) el.parentNode.removeChild(el);
  },
  update(el, binding, vnode, oldVnode) {},
  componentUpdated(el, binding, vnode, oldVnode) {},
  unbind(el, binding, vnode, oldVnode) {}
};


// WEBPACK FOOTER //
// ./src/directives/permission/index.js